var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"whatsapp-bubble",attrs:{"href":_vm.whatsappLink,"target":"_blank","rel":"noopener noreferrer"},on:{"click":_vm.trackClick}},[_c('i',{staticClass:"fab fa-whatsapp"}),_c('span',{staticClass:"bubble-text"},[_vm._v("Chat with us")])])
}
var staticRenderFns = []

export { render, staticRenderFns }